import React from 'react';
import './AssetDetailsModal.css';

const AssetDetailsModal = ({ isOpen, onClose, assetData }) => {
    if (!isOpen || !assetData) return null;

    const formatValue = (value) => {
        if (value === null || value === undefined || value === '') {
            return 'N/A';
        }
        if (typeof value === 'boolean') {
            return value ? 'Yes' : 'No';
        }
        if (typeof value === 'object' && value._id) {
            return value._id;
        }
        if (Array.isArray(value)) {
            return value.length > 0 ? value.join(', ') : 'N/A';
        }
        return value.toString();
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleDateString();
        } catch {
            return dateString;
        }
    };

    const renderAssetField = (label, value, isDate = false) => (
        <div className="asset-field">
            <div className="asset-field-label">{label}</div>
            <div className="asset-field-value">
                {isDate ? formatDate(value) : formatValue(value)}
            </div>
        </div>
    );

    const renderSection = (title, data) => {
        if (!data || typeof data !== 'object') return null;
        
        return (
            <div className="asset-section">
                <h4 className="asset-section-title">{title}</h4>
                <div className="asset-section-content">
                    {Object.entries(data).map(([key, value]) => (
                        <div key={key} className="asset-field">
                            <div className="asset-field-label">
                                {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                            </div>
                            <div className="asset-field-value">{formatValue(value)}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="asset-modal-overlay" onClick={onClose}>
            <div className="asset-modal" onClick={(e) => e.stopPropagation()}>
                <div className="asset-modal-header">
                    <h2>Asset Details</h2>
                    <button className="asset-modal-close" onClick={onClose}>×</button>
                </div>
                
                <div className="asset-modal-content">
                    {/* Basic Asset Information */}
                    <div className="asset-section">
                        <h4 className="asset-section-title">Basic Information</h4>
                        <div className="asset-section-content">
                            {renderAssetField('Asset ID', assetData._id)}
                            {renderAssetField('Name', assetData.name)}
                            {renderAssetField('Asset Type', assetData.assetType)}
                            {renderAssetField('Manufacturer', assetData.manufacturer)}
                            {renderAssetField('Model Number', assetData.modelNumber)}
                            {renderAssetField('Serial Number', assetData.serialNumber)}
                            {renderAssetField('Location', assetData.location)}
                            {renderAssetField('Supports', assetData.supports)}
                            {renderAssetField('Energy Source', assetData.energySource)}
                        </div>
                    </div>

                    {/* Warranty Information */}
                    <div className="asset-section">
                        <h4 className="asset-section-title">Warranty Information</h4>
                        <div className="asset-section-content">
                            {renderAssetField('Warranty Expiration', assetData.warrantyExpiration, true)}
                            {renderAssetField('Last Service', assetData.lastService, true)}
                            {renderAssetField('Service Contract', assetData.serviceContract)}
                            {renderAssetField('Date Installed', assetData.dateInstalled, true)}
                        </div>
                    </div>

                    {/* HVAC Settings */}
                    {assetData.HVACSettings && renderSection('HVAC Settings', assetData.HVACSettings)}

                    {/* HVAC Split Settings */}
                    {assetData.HVACSplitSettings && renderSection('HVAC Split Settings', assetData.HVACSplitSettings)}

                    {/* Supported Suites */}
                    {assetData.supportedSuites && assetData.supportedSuites.length > 0 && (
                        <div className="asset-section">
                            <h4 className="asset-section-title">Supported Suites</h4>
                            <div className="asset-section-content">
                                {renderAssetField('Suites', assetData.supportedSuites)}
                            </div>
                        </div>
                    )}

                    {/* Images */}
                    {assetData.images && assetData.images.length > 0 && (
                        <div className="asset-section">
                            <h4 className="asset-section-title">Images</h4>
                            <div className="asset-section-content">
                                {renderAssetField('Image Count', assetData.images.length)}
                            </div>
                        </div>
                    )}

                    {/* Occupied Days */}
                    {assetData.occupiedDays && assetData.occupiedDays.length > 0 && (
                        <div className="asset-section">
                            <h4 className="asset-section-title">Occupied Days</h4>
                            <div className="asset-section-content">
                                {renderAssetField('Days', assetData.occupiedDays)}
                            </div>
                        </div>
                    )}

                    {/* Building ID */}
                    {assetData.buildingId && (
                        <div className="asset-section">
                            <h4 className="asset-section-title">Building Information</h4>
                            <div className="asset-section-content">
                                {renderAssetField('Building ID', assetData.buildingId)}
                            </div>
                        </div>
                    )}
                </div>

                <div className="asset-modal-footer">
                    <button className="asset-modal-btn-close" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AssetDetailsModal;